import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MomentModule } from 'ngx-moment';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination"
import { TimepickerModule } from 'ngx-bootstrap/timepicker'

import {
    DeviceIndexComponent,
    DeviceListComponent,
    DeviceFilterComponent
} from './index';

import { DeviceRouting } from './index';
import { SharedModule } from './../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        MomentModule,
        PaginationModule.forRoot(),
        FormsModule,

        SharedModule,

        DeviceRouting,

        ModalModule.forRoot()
    ],
    declarations: [
        DeviceIndexComponent,
        DeviceListComponent,
        DeviceFilterComponent
    ]
})
export class DeviceModule { }
